/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteEmployees = gql`
  mutation DeleteEmployees($ids: [ID!]!) {
    deleteEmployees(ids: $ids)
  }
`;
